/*
 * @Author: yexiu
 * @Date: 2024-12-10 14:44:08
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 14:04:26
 */
import { App } from 'vue';

export default (app: App, parameter: DevelopToolShare.InitParams)=>{
    app.mixin({
        computed: {
            MIXIN_LANG(){ return parameter.countryCode },
            MIXIN_TEXT(){ return parameter.reactText },
            MIXIN_DOMAIN(){ return parameter.reactDomain },
            MIXIN_ACTIVITY_INFO(){ return parameter.reactActivityInfo },
            MIXIN_RULE:{
                get(){
                    return parameter.fnLazyRule();
                }
            }
        }
    });
}